export const capitalizeWords = (text: string): string => {
  return text.split(' ').map(word => 
    word.charAt(0).toUpperCase() + word.slice(1)
  ).join(' ');
};